import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getUnitMeasurementList,
	addNewUnitMeasurement,
	updateUnitMeasurement,
	deleteUnitMeasurement,
	getUnitMeasurement,
    getUnitMeasurementByCode,
} from '../unitMeasurement/thunk';

export const initialState = {
	itemUnitMeasurementList: [],
	itemUnitMeasurementDetail: null,
	isUnitMeasurementLoading: false,
	isUnitMeasurementSuccess: false,

    dataUnitMeasurement: null,
	unitMeasurementList: [],
	unitMeasurementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const UnitMeasurementSlice = createSlice({
	name: 'UnitMeasurements',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getUnitMeasurement.fulfilled, (state, action) => {
			state.isUnitMeasurementLoading = false;
			state.isUnitMeasurementSuccess = true;
			state.itemUnitMeasurementDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getUnitMeasurement.pending, state => {
			state.isUnitMeasurementLoading = true;
			state.isUnitMeasurementSuccess = null;
			state.error = null;
            state.itemUnitMeasurementDetail = null;
			state.isLoadingList = true;
		});
		builder.addCase(getUnitMeasurement.rejected, (state, action) => {
			state.isUnitMeasurementLoading = false;
			state.isUnitMeasurementSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getUnitMeasurementList.pending, state => {
			state.isUnitMeasurementSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getUnitMeasurementList.fulfilled, (state, action) => {
			state.itemUnitMeasurementList = action.payload;
			state.unitMeasurementList = action.payload;
			state.isLoadingList = false;
			state.isUnitMeasurementSuccess = true;

			let unitMeasurementListSelect = [];
			action.payload.map(item =>
				unitMeasurementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.unitMeasurementListSelect = unitMeasurementListSelect;
		});
		builder.addCase(getUnitMeasurementList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUnitMeasurementSuccess = true;
		});
		builder.addCase(addNewUnitMeasurement.fulfilled, (state, action) => {
			state.itemUnitMeasurementList.push(action.payload);
			state.unitMeasurementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewUnitMeasurement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewUnitMeasurement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateUnitMeasurement.fulfilled, (state, action) => {
			state.itemUnitMeasurementList = state.itemUnitMeasurementList.map(unitMeasurement =>
				unitMeasurement.unitMeasurementname === action.payload.old_unitMeasurement
					? { ...unitMeasurement, ...action.payload.updated_unitMeasurement }
					: unitMeasurement
			);
			state.unitMeasurementList = state.unitMeasurementList.map(unitMeasurement =>
				unitMeasurement._id.toString() === action.payload._id.toString()
					? { ...unitMeasurement, ...action.payload }
					: unitMeasurement
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateUnitMeasurement.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateUnitMeasurement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteUnitMeasurement.fulfilled, (state, action) => {
			state.itemUnitMeasurementList = current(state.itemUnitMeasurementList).filter(
				item => item._id !== action.payload._id
			);
			state.unitMeasurementList = current(state.unitMeasurementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteUnitMeasurement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteUnitMeasurement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

        builder.addCase(getUnitMeasurementByCode.fulfilled, (state, action) => {
			state.dataUnitMeasurement = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getUnitMeasurementByCode.pending, (state, action) => {
            state.dataUnitMeasurement = null;
			state.isLoadingList = false;
		});
		builder.addCase(getUnitMeasurementByCode.rejected, (state, action) => {
            state.dataUnitMeasurement = null;
			state.isLoadingList = true;
		});
	},
});

export const { setRequireCloseModal } = UnitMeasurementSlice.actions;

export default UnitMeasurementSlice.reducer;
